import $ from 'jquery';
import { localize, notify } from '../../compat/core';

const Resx = localize('Common', 'App', 'Messages');

export default function () {
    $(document).off('click', '[data-control-userassignment]', toggleAssignment);
    $(document).on('click', '[data-control-userassignment]', toggleAssignment);
}

function toggleAssignment() {
    var userId = $(this).attr('data-control-userassignment');
    var entityId = $(this).attr('data-control-entity-id');
    var svcName = $(this).attr('data-control-service-name');

    let service = abp.services.api[svcName];
    service.toggleAssignment(entityId, userId)
        .done(function () {
            notify.success(Resx.Common.SettingsSaved);

            refreshDataTable('usersGrid_Supplier,usersGrid_Customer');
        }).fail(function () {
            notify.error(Resx.Common.AjaxError);
        });
}
